import React from "react";
import TextField from "@material-ui/core/TextField";
import { connect, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";

// Buyer (Aranan) ilan: kabul edilen yıl aralığı (yearMin - yearMax).
// Redux: newAdvert.filters.yearMin, newAdvert.filters.yearMax.
function FLBuyerYearRange(props) {
  const { filters } = useSelector((state) => ({
    filters: state.advert.newAdvert.filters,
  }));

  const yearMin = filters?.yearMin ?? "";
  const yearMax = filters?.yearMax ?? "";
  const currentYear = new Date().getFullYear();

  return (
    <div style={{ display: "flex", gap: 8, width: "100%" }}>
      <TextField
        type="number"
        label="En Az Yıl"
        variant="outlined"
        margin="dense"
        fullWidth
        value={yearMin}
        onChange={(e) =>
          props.editNewAdvertFilters(
            "yearMin",
            e.target.value === "" ? "" : Number(e.target.value)
          )
        }
        inputProps={{ min: 1900, max: currentYear + 1 }}
        placeholder="2015"
      />
      <TextField
        type="number"
        label="En Çok Yıl"
        variant="outlined"
        margin="dense"
        fullWidth
        value={yearMax}
        onChange={(e) =>
          props.editNewAdvertFilters(
            "yearMax",
            e.target.value === "" ? "" : Number(e.target.value)
          )
        }
        inputProps={{ min: 1900, max: currentYear + 1 }}
        placeholder={String(currentYear)}
      />
    </div>
  );
}

export default connect(null, { ...advertRedux.actions })(FLBuyerYearRange);
